import { render, staticRenderFns } from "./researchNewsView.vue?vue&type=template&id=00901177&scoped=true&"
import script from "./researchNewsView.vue?vue&type=script&lang=js&"
export * from "./researchNewsView.vue?vue&type=script&lang=js&"
import style0 from "./researchNewsView.vue?vue&type=style&index=0&id=00901177&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00901177",
  null
  
)

export default component.exports